var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center space-x-3"},_vm._l((_vm.options),function(ref,index){
var name = ref.name;
var val = ref.value;
var invalid = ref.invalid;
var label = ref.label;
var dataTestId = ref.dataTestId;
return _c('SfRadio',{key:index,attrs:{"name":name,"label":label,"disabled":_vm.disabled,"value":val,"invalid":invalid,"data-test":dataTestId},model:{value:(_vm.proxyChecked),callback:function ($$v) {_vm.proxyChecked=$$v},expression:"proxyChecked"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }